import { CommunityInfo } from "@circle-react/components/LiveStreams/Room/Header/CommunityInfo";
import { Toolbar } from "@circle-react/components/LiveStreams/Room/Toolbar";
import { CurrentCommunityMemberAvatar } from "../../CurrentCommunityMemberAvatar";

export const Header = () => {
  const isComingFromReactNativeWebview =
    window.webview?.isComingFromReactNativeWebview;

  const goBack = () => {
    if (isComingFromReactNativeWebview) {
      window.webview?.onEndLiveStream?.();
      return;
    }
    window.location.href = "/";
  };

  return (
    <Toolbar>
      <Toolbar.Group>
        <CommunityInfo onClick={goBack} />
      </Toolbar.Group>
      <Toolbar.Group>
        {!isComingFromReactNativeWebview && (
          <CurrentCommunityMemberAvatar size="8" hasBorder />
        )}
      </Toolbar.Group>
    </Toolbar>
  );
};
